import { render } from "./CatSocioNegocioView.vue?vue&type=template&id=ac3f5952&scoped=true"
import script from "./CatSocioNegocioView.vue?vue&type=script&lang=js"
export * from "./CatSocioNegocioView.vue?vue&type=script&lang=js"

import "./CatSocioNegocioView.vue?vue&type=style&index=0&id=ac3f5952&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac3f5952"]])

export default __exports__